<div class="row">
  <div class="col-12">
    <div
      class="page-title-box d-flex flex-wrap align-items-start justify-content-between gap-2"
    >
      <div>
        <h4 class="page-title mb-1">
          {{ "campaign.campaignList.pageTitle" | translate }}
        </h4>
      </div>
      <div class="d-flex flex-wrap align-items-center gap-2 mt-3">
        <campaign-wallet />
        <campaign-refresh-interval />
      </div>
    </div>
  </div>
</div>

<!-- Abas do módulo -->
<ul class="nav nav-tabs nav-bordered mb-2" role="tablist">
  <li class="nav-item" role="presentation">
    <a
      class="nav-link active"
      href="javascript:void(0);"
      role="tab"
      [attr.aria-selected]="true"
    >
      {{ "campaign.campaignList.tabCampaigns" | translate }}
    </a>
  </li>
  @if (isAdmin()) {
    <li class="nav-item" role="presentation">
      <a
        class="nav-link"
        role="tab"
        [attr.aria-selected]="false"
        [routerLink]="['/campaign/list-template']"
      >
        {{ "campaign.campaignList.tabTemplates" | translate }}
      </a>
    </li>
  }
</ul>

<!-- Filtros -->
<div class="card mb-2">
  <div class="card-body">
    <div class="row g-2 align-items-center">
      <div class="col-12 col-lg-5 input-trend-search">
        <input
          type="search"
          #searchBox
          class="form-control"
          [placeholder]="'campaign.campaignList.searchPlaceholder' | translate"
          [attr.aria-label]="
            'campaign.campaignList.searchPlaceholder' | translate
          "
          [value]="searchString"
          (keyup)="search(searchBox.value)"
        />
        <span class="mdi mdi-magnify search-icon"></span>
      </div>

      <div class="col-12 col-md-6 col-lg-2 btn-group trend-button">
        <button
          type="button"
          class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
          [matMenuTriggerFor]="filterChannel"
        >
          <span>{{ labelFilterChannel | translate }}</span>
        </button>
        <mat-menu #filterChannel="matMenu">
          <button mat-menu-item type="button" (click)="onChannelChange('')">
            {{ "campaign.campaignList.allChannels" | translate }}
          </button>
          @for (channel of channels; track channel._id) {
            <button
              mat-menu-item
              type="button"
              (click)="onChannelChange(channel._id)"
            >
              {{ channel.name }}
            </button>
          }
        </mat-menu>
      </div>

      <!-- Filtro de período -->
      <div
        class="col-12 col-md-6 col-lg-3 trend-datepicker"
        [formGroup]="filterForm"
      >
        <mat-date-range-input [rangePicker]="picker" formGroupName="dateRange">
          <input
            matStartDate
            formControlName="dateStart"
            [placeholder]="'campaign.campaignList.periodStart' | translate"
          />
          <input
            matEndDate
            formControlName="dateEnd"
            [placeholder]="'campaign.campaignList.periodEnd' | translate"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
          [attr.aria-label]="
            'campaign.campaignList.periodFilterLabel' | translate
          "
        />
        <mat-date-range-picker #picker>
          <mat-datepicker-actions>
            <mat-select
              class="input-field rounded-lg"
              (selectionChange)="onPeriodChange($event)"
              [placeholder]="'campaign.campaignList.periodSelect' | translate"
            >
              <mat-option value="1">
                {{ "campaign.campaignList.periodToday" | translate }}
              </mat-option>
              <mat-option value="7">
                {{ "campaign.campaignList.periodLast7Days" | translate }}
              </mat-option>
              <mat-option value="15">
                {{ "campaign.campaignList.periodLast15Days" | translate }}
              </mat-option>
              <mat-option value="30">
                {{ "campaign.campaignList.periodLast30Days" | translate }}
              </mat-option>
              <mat-option value="60">
                {{ "campaign.campaignList.periodLast60Days" | translate }}
              </mat-option>
            </mat-select>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              matDatepickerApply
            >
              {{ "campaign.campaignList.periodApply" | translate }}
            </button>
          </mat-datepicker-actions>
        </mat-date-range-picker>
      </div>

      <div class="col-12 col-md-6 col-lg-2 trend-button">
        <button
          type="button"
          class="btn btn-success fw-bold w-100"
          (click)="showNewCampaign()"
        >
          <i class="mdi mdi-plus"></i>
          <span>{{ "campaign.campaignList.newCampaign" | translate }}</span>
        </button>
      </div>
    </div>

    <ul class="nav campaign-status-filter mt-2" role="tablist">
      @for (item of campaignStatuses; track item.label) {
        <li class="nav-item" role="presentation">
          <a
            class="nav-link"
            href="javascript:void(0);"
            role="tab"
            [class.active]="isStatusActive(item.status)"
            [attr.aria-selected]="isStatusActive(item.status)"
            (click)="setStatusFilter(item.status)"
          >
            {{ item.label | translate }}
          </a>
        </li>
      }
    </ul>
  </div>
</div>

@if (!loadingContent) {
  <div class="card-body mb-3">
    <div class="d-flex flex-wrap gap-2">
      <div class="flex-fill">
        <card-graphic-small-component
          [label]="'campaign.campaignList.totalCampaigns' | translate"
          [total]="totalCampaign | number: '1.0-0'"
          [description]="
            'campaign.campaignList.kpiHintSelectedPeriod' | translate
          "
          [iconClass]="'mdi mdi-bullhorn-outline'"
          [tone]="'primary'"
        />
      </div>
      <div class="flex-fill">
        <card-graphic-small-component
          [label]="'campaign.campaignList.totalMessages' | translate"
          [total]="totalSent | number: '1.0-0'"
          [description]="
            (totalFailed | number: '1.0-0') +
            ' ' +
            ('campaign.campaignList.kpiFailedSuffix' | translate)
          "
          [iconClass]="'mdi mdi-send-outline'"
          [tone]="'info'"
          [descriptionTone]="hasFailures ? 'danger' : null"
        />
      </div>
      <div class="flex-fill">
        <card-graphic-small-component
          [label]="'campaign.campaignList.deliveryRate' | translate"
          [total]="deliveryRateLabel"
          [description]="
            (totalDelivered | number: '1.0-0') +
            ' ' +
            ('campaign.campaignList.kpiDeliveredSuffix' | translate) +
            ' · ' +
            deliveryTrendLabel
          "
          [iconClass]="'mdi mdi-check-circle-outline'"
          [tone]="'success'"
          [descriptionTone]="deliveryTrendTone"
        />
      </div>
      <div class="flex-fill">
        <card-graphic-small-component
          [label]="'campaign.campaignList.totalCost' | translate"
          [total]="totalCoust ?? 0 | currency: 'BRL' : 'symbol' : '1.2-2'"
          [description]="'campaign.campaignList.kpiHintPeriodTotal' | translate"
          [iconClass]="'mdi mdi-cash-multiple'"
          [tone]="'warning'"
        />
      </div>
    </div>
  </div>

  <div
    class="alert alert-info d-flex align-items-start gap-1 mb-2"
    role="alert"
  >
    <i class="mdi mdi-information-outline text-info"></i>
    <span>
      {{ "campaign.campaignList.dataScopeInfo" | translate }}
      <strong class="ms-1">
        {{ "campaign.campaignList.noteLabel" | translate }}
      </strong>
      {{ "campaign.campaignList.estimateNote" | translate }}
    </span>
  </div>
}

<!-- Lista -->
<div class="card">
  @if (loadingContent) {
    <content-loading-list />
  } @else if (pager.total === 0) {
    <empty-records-component
      [message]="'campaign.campaignList.emptyMessage' | translate"
      [subMessage]="'campaign.campaignList.emptySubMessage' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
    />
  } @else {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">
              {{ "campaign.campaignList.columnCampaign" | translate }}
            </th>
            <th class="text-primary-emphasis">
              {{ "campaign.campaignList.columnSendDateTime" | translate }}
            </th>
            <th class="text-primary-emphasis">
              {{ "campaign.campaignList.columnAudience" | translate }}
            </th>
            <th class="text-primary-emphasis">
              {{ "campaign.campaignList.columnStatus" | translate }}
            </th>
            <th class="text-end text-primary-emphasis">
              {{ "campaign.campaignList.columnLeads" | translate }}
            </th>
            <th class="text-end text-primary-emphasis">
              {{ "campaign.campaignList.columnCost" | translate }}
            </th>
            <th>
              <span class="visually-hidden">{{
                "campaign.campaignList.actionsMenu" | translate
              }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (campaign of pager.list; track campaign._id) {
            <tr
              class="cursor-pointer"
              tabindex="0"
              role="button"
              [attr.aria-label]="
                ('campaign.campaignList.openCampaign' | translate) +
                ': ' +
                campaign.name
              "
              (click)="listCampaignContact(campaign)"
              (keydown.enter)="listCampaignContact(campaign)"
              (keydown.space)="
                listCampaignContact(campaign); $event.preventDefault()
              "
            >
              <!-- Disparo + canal -->
              <td>
                <div class="d-flex flex-column">
                  <span [matTooltip]="campaign.name">
                    {{ campaign.name | truncate: 40 }}
                  </span>
                  <span
                    class="text-muted font-13 d-inline-flex align-items-center"
                    [matTooltip]="$safeNavigationMigration(campaign.channel?.name)"
                  >
                    @if (campaign.channel?.type) {
                      <img
                        [src]="getChannelIcon(campaign.channel)"
                        class="me-1"
                        height="14"
                        [alt]="$safeNavigationMigration(campaign.channel?.name)"
                      />
                    }
                    {{ $safeNavigationMigration(campaign.channel?.name) | truncate: 40 }}
                  </span>
                </div>
              </td>

              <td>
                <div class="d-flex flex-column">
                  <span>
                    {{
                      campaign.scheduledDate
                        | timezoneDate
                          : "DD/MM/YYYY HH:mm"
                          : getTimezoneCompanyCurrentUser()
                    }}
                  </span>
                  <span class="text-muted font-13">
                    @if (campaign.executionType === "IMEDIATE") {
                      {{
                        "campaign.campaignList.executionImmediate" | translate
                      }}
                    } @else {
                      {{
                        "campaign.campaignList.executionScheduled" | translate
                      }}
                    }
                  </span>
                </div>
              </td>
              <td>
                @switch (campaign.audienceType) {
                  @case ("ALL_LEADS") {
                    <span class="badge bg-light text-dark font-12">
                      {{ "campaign.campaignList.audienceAllLeads" | translate }}
                    </span>
                  }
                  @case ("TAGS") {
                    @if (campaign.audienceTags?.length) {
                      <div class="d-flex flex-wrap gap-1">
                        @for (
                          tag of campaign.audienceTags | slice: 0 : 3;
                          track tag._id
                        ) {
                          <span
                            class="badge font-12 text-capitalize"
                            [ngStyle]="{
                              'background-color': tag.bgColor,
                              color: (tag.bgColor | readableText: tag.fontColor),
                            }"
                            matTooltip="{{ tag.title }}"
                          >
                            {{ tag.title | truncate: 15 }}
                          </span>
                        }
                        @if (campaign.audienceTags.length > 3) {
                          <span
                            class="badge bg-light text-dark font-12 cursor-pointer"
                            [matMenuTriggerFor]="moreTagsMenu"
                            (click)="$event.stopPropagation()"
                            [matTooltip]="
                              'campaign.campaignList.viewMoreAudience'
                                | translate
                            "
                          >
                            +{{ campaign.audienceTags.length - 3 }}
                          </span>
                          <mat-menu
                            #moreTagsMenu="matMenu"
                            class="custom-menu-panel"
                          >
                            <div
                              class="d-flex flex-column gap-1 p-2"
                              (click)="$event.stopPropagation()"
                            >
                              @for (
                                tag of campaign.audienceTags | slice: 3;
                                track tag._id
                              ) {
                                <span
                                  class="badge font-12 text-capitalize"
                                  [ngStyle]="{
                                    'background-color': tag.bgColor,
                                    color: (tag.bgColor | readableText: tag.fontColor),
                                  }"
                                >
                                  {{ tag.title }}
                                </span>
                              }
                            </div>
                          </mat-menu>
                        }
                      </div>
                    } @else {
                      <span class="text-muted">-</span>
                    }
                  }
                  @case ("CONTACT_GROUP") {
                    @if (campaign.audienceContactGroup?.length) {
                      <div class="d-flex flex-wrap gap-1">
                        @for (
                          group of campaign.audienceContactGroup | slice: 0 : 3;
                          track group._id
                        ) {
                          <span
                            class="badge bg-light text-dark font-12"
                            matTooltip="{{ group.name }}"
                          >
                            {{ group.name | truncate: 15 }}
                          </span>
                        }
                        @if (campaign.audienceContactGroup.length > 3) {
                          <span
                            class="badge bg-light text-dark font-12 cursor-pointer"
                            [matMenuTriggerFor]="moreGroupsMenu"
                            (click)="$event.stopPropagation()"
                            [matTooltip]="
                              'campaign.campaignList.viewMoreAudience'
                                | translate
                            "
                          >
                            +{{ campaign.audienceContactGroup.length - 3 }}
                          </span>
                          <mat-menu
                            #moreGroupsMenu="matMenu"
                            class="custom-menu-panel"
                          >
                            <div
                              class="d-flex flex-column gap-1 p-2"
                              (click)="$event.stopPropagation()"
                            >
                              @for (
                                group of campaign.audienceContactGroup
                                  | slice: 3;
                                track group._id
                              ) {
                                <span
                                  class="badge bg-light text-dark font-12"
                                  >{{ group.name }}</span
                                >
                              }
                            </div>
                          </mat-menu>
                        }
                      </div>
                    } @else {
                      <span class="text-muted">-</span>
                    }
                  }
                  @default {
                    <!-- FILE: a listagem não popula `audienceFile`, então aqui
                         só cabe o rótulo do tipo de público, não o nome do
                         arquivo. -->
                    <span class="badge bg-light text-dark font-12">{{
                      "campaign.campaignList.audienceFile" | translate
                    }}</span>
                  }
                }
              </td>

              <!-- Status -->
              <td>
                @if (campaign.enabled === false) {
                  <span class="badge campaign-badge is-neutral">
                    <span class="campaign-badge-dot"></span
                    >{{ "campaign.campaignList.statusDraft" | translate }}
                  </span>
                } @else {
                  @switch (campaign.status) {
                    @case ("WAITING") {
                      <span class="badge campaign-badge is-warn">
                        <span class="campaign-badge-dot"></span
                        >{{ "campaign.campaignList.statusWaiting" | translate }}
                      </span>
                    }
                    @case ("SENDING") {
                      <span
                        class="badge campaign-badge campaign-badge-running is-run"
                      >
                        <span class="campaign-badge-dot"></span
                        >{{ "campaign.campaignList.statusSending" | translate }}
                      </span>
                    }
                    @case ("DONE") {
                      @if (failureOf(campaign); as failure) {
                        <span class="badge campaign-badge is-warn">
                          <span class="campaign-badge-dot"></span
                          >{{
                            "campaign.campaignList.statusDoneWithErrors"
                              | translate
                          }}
                        </span>
                        <div class="campaign-subtext">
                          {{
                            "campaign.campaignList.failureRatio"
                              | translate
                                : {
                                    failed: failure.failed,
                                    total: failure.dispatchable,
                                  }
                          }}
                        </div>
                      } @else {
                        <span class="badge campaign-badge is-ok">
                          <span class="campaign-badge-dot"></span
                          >{{ "campaign.campaignList.statusDone" | translate }}
                        </span>
                      }
                    }
                    @case ("CANCELED") {
                      <span class="badge campaign-badge is-neutral">
                        <span class="campaign-badge-dot"></span
                        >{{
                          "campaign.campaignList.statusCanceled" | translate
                        }}
                      </span>
                    }
                    @case ("ERROR") {
                      <span class="badge campaign-badge is-err">
                        <span class="campaign-badge-dot"></span
                        >{{ "campaign.campaignList.statusError" | translate }}
                      </span>
                    }
                    @default {
                      <span class="badge campaign-badge is-neutral">
                        <span class="campaign-badge-dot"></span
                        >{{ "campaign.campaignList.statusUnknown" | translate }}
                      </span>
                    }
                  }
                }
              </td>

              <!-- Leads -->
              <td class="text-end">
                @if (campaign.leadCount != null) {
                  <span>{{ campaign.leadCount }}</span>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>

              <td class="text-end">
                @if (campaign.cost > 0) {
                  <span>
                    {{
                      campaign.cost ?? 0 | currency: "BRL" : "symbol" : "1.2-2"
                    }}
                  </span>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>

              <!-- Ações -->
              <td>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-dropdown-list"
                    type="button"
                    [matMenuTriggerFor]="menu"
                    [attr.aria-label]="
                      'campaign.campaignList.actionsMenu' | translate
                    "
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>
                </div>
                <mat-menu #menu="matMenu">
                  @if (campaign.enabled === false) {
                    <button
                      mat-menu-item
                      type="button"
                      (click)="edit(campaign); $event.stopPropagation()"
                    >
                      {{ "campaign.campaignList.actionEdit" | translate }}
                    </button>
                  }
                  @if (
                    campaign.enabled === true &&
                    (campaign.status === "SENDING" ||
                      campaign.status === "WAITING")
                  ) {
                    <button
                      mat-menu-item
                      type="button"
                      (click)="cancel(campaign); $event.stopPropagation()"
                    >
                      {{ "campaign.campaignList.actionCancel" | translate }}
                    </button>
                  }
                  <button
                    mat-menu-item
                    type="button"
                    (click)="cloneCampaign(campaign); $event.stopPropagation()"
                  >
                    {{ "campaign.campaignList.actionClone" | translate }}
                  </button>
                  @if (
                    campaign.enabled === false || campaign.status === "ERROR"
                  ) {
                    <button
                      mat-menu-item
                      type="button"
                      (click)="delete(campaign); $event.stopPropagation()"
                    >
                      {{ "campaign.campaignList.actionDelete" | translate }}
                    </button>
                  }
                </mat-menu>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
      }
    </div>
  }
</div>
